import ICSSProperties from '../../../typings/css-properties';


export const datepicker: ICSSProperties = {
  position: 'fixed',
  overflow: 'hidden',
  visibility: 'hidden'
};


export const datepickerDropdown: ICSSProperties = {
  '& .ant-calendar-input-wrap': {
    display: 'none'
  }
};
